import { render, staticRenderFns } from "./points-grant-form.vue?vue&type=template&id=f61420ba&"
import script from "./points-grant-form.vue?vue&type=script&lang=js&"
export * from "./points-grant-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports